/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section4_TitleInputs */

const en_privacy_section4_title = /** @type {(inputs: Privacy_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-Party Services`)
};

const ko_privacy_section4_title = /** @type {(inputs: Privacy_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제3자 서비스`)
};

const ja_privacy_section4_title = /** @type {(inputs: Privacy_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サードパーティサービス`)
};

/**
* | output |
* | --- |
* | "Third-Party Services" |
*
* @param {Privacy_Section4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section4_title = /** @type {((inputs?: Privacy_Section4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section4_title(inputs)
	if (locale === "ko") return ko_privacy_section4_title(inputs)
	return ja_privacy_section4_title(inputs)
});